import React from 'react';
import { cn } from '../utils';

export interface HeroProps {
  variant?: 'default' | 'overlay' | 'centered';
  backgroundImage?: string;
  minHeight?: 'sm' | 'md' | 'lg' | 'full';
  className?: string;
  children: React.ReactNode;
}

export const Hero: React.FC<HeroProps> = ({
  variant = 'default',
  backgroundImage,
  minHeight = 'md',
  className,
  children,
}) => {
  const heightClasses = {
    sm: 'min-h-[300px]',
    md: 'min-h-[500px]',
    lg: 'min-h-[700px]',
    full: 'min-h-screen',
  };

  const style = backgroundImage
    ? {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    : {};

  if (variant === 'overlay' && backgroundImage) {
    return (
      <div className={cn('hero', heightClasses[minHeight], className)} style={style}>
        <div className="hero-overlay bg-opacity-60"></div>
        <div className="hero-content text-center text-neutral-content">{children}</div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'hero',
        heightClasses[minHeight],
        variant === 'centered' && 'place-items-center',
        className
      )}
      style={style}
    >
      <div className="hero-content">{children}</div>
    </div>
  );
};
